import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';

const CustomRadioButton = (props) => {
    return (
        <Radio
            inputProps={{ 'data-testid': props.name }}
            {...props}
        />
    );
};

CustomRadioButton.propTypes = {
    checked: PropTypes.bool,
    disableRipple: PropTypes.bool,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
};

CustomRadioButton.defaultProps = {
    id: 'custom-radio-button',
    disableRipple: true
};

export default CustomRadioButton;
